import { BeaconErrorType } from '@airgap/beacon-types';
import { BeaconError } from './BeaconError';
/**
 * @category Error
 */
export class NoPrivateKeyBeaconError extends BeaconError {
    name = 'NoPrivateKeyBeaconError';
    title = 'Account Not Found';
    constructor() {
        super(BeaconErrorType.NO_PRIVATE_KEY_FOUND_ERROR, 'The account you are trying to interact with is not available. Please make sure to add the account to your wallet and try again.');
    }
}
//# sourceMappingURL=NoPrivateKeyBeaconError.js.map